import { Link } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";
import { Reveal } from "../components/Reveal";
import { LOGO_URL, MANIFESTO } from "../config/brand";

export default function AboutPage() {
  useSEO("ABOUT — RICH KIDS FUNERAL", "RICH KIDS FUNERAL is a memorial to the life we refused to live quietly.");

  return (
    <div className="px-4 md:px-6 pt-16 md:pt-24 pb-8 max-w-4xl mx-auto text-center" data-testid="about-page">
      <Reveal>
        <img src={LOGO_URL} alt="Rich Kids Funeral" className="h-12 md:h-16 w-auto mx-auto" />
      </Reveal>
      <Reveal delay={0.15}>
        <p className="font-anton text-lg md:text-3xl leading-[1.7] tracking-[0.01em] mt-14 text-left" data-testid="about-manifesto">
          {MANIFESTO}
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <Link
          to="/all-products"
          className="inline-block mt-16 text-[11px] font-medium tracking-[0.2em] border border-black px-10 py-4 hover:bg-black hover:text-white transition-colors"
        >
          SHOP FIRST COLLECTION 26
        </Link>
      </Reveal>
    </div>
  );
}
